<template>
    <div class="titleBlock">
        <div class="block__primary">
            <div class="primarySubtitle" v-if="primarySubtitle" v-html="primarySubtitle"></div>
            <div class="primaryTitle" v-if="primaryTitle" v-html="primaryTitle"></div>
        </div>
        <div class="block__secondary" v-if="secondaryContent" >
            <span v-html="secondaryContent"></span>
            <ButtonPulse :btnContent="buttonLabel" iconType="arrow" class="homeButton" @click="$emit('buttonPulseClick')"/>
        </div>
    </div>
</template>

<script>
import ButtonPulse from '@/components/ButtonPulse'

export default {
    name: 'TitleBlock',
    props: ['primaryTitle', 'primarySubtitle', 'secondaryContent', 'buttonLabel'],
    components: {
        ButtonPulse
    }
}
</script>

<style scoped lang="scss">
.titleBlock {
    position: relative;
}
.block__primary {
    background-color: $colour__primary1;
    color: $white;
    padding: 3rem 3.6rem;
    position: relative;
    width: 50rem;
    display: block;
    text-align: left;
}
.primaryTitle {
    .primarySubtitle + & {
        margin-top: 1rem;
    }
    font-size: 4.8rem;
    line-height: 1;
}
.primarySubtitle {
    text-transform: uppercase;
    color: $colour__accent1;
    font-size: 1.8rem;
}

.block__secondary {
    background-color: $colour__primary2;
    color: $colour__primary1;
    padding: 3rem 3.6rem;
    font-size: 1.8rem;
    position: relative;
    width: 50rem;
    margin-top: -1.25rem;
    margin-left: 3.6rem;
    margin-right: 2.6rem;
    margin-bottom: 4.3rem;
    display: block;
    text-align: left;
}
.homeButton {
    position: absolute;
    top: calc(100% - 1.8rem);
    right: -2.6rem;
}

</style>

<style lang="scss">
div.block__secondary {
    p, span {
        font-size: inherit;
        line-height: inherit;
        margin-bottom: 0;
        &:not(:first-child) {
            margin-top: 1rem;
        }
    }
}
</style>
